export const Persistence = {
  PERSISTENT: "PERSISTENT",
  NON_PERSISTENT: "NON_PERSISTENT",
};

export const MessageType = {
  STANDARD: "STANDARD",
  CONTROL: "CONTROL",
};
